import { rootApi } from '../../services/rootApi';
import { generateMockCalendarEvents } from './data/mockCalendarEvents';

export const classroomApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // Mock endpoint -- returns local mock data until backend API exists
    getClassroomEvents: builder.query({
      queryFn: ({ groupId } = {}) => {
        const events = generateMockCalendarEvents();
        const filtered = groupId
          ? events.filter((e) => !e.extendedProps?.groupId || e.extendedProps.groupId === groupId)
          : events;
        return { data: filtered };
      },
      providesTags: ['ClassroomEvent'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetClassroomEventsQuery } = classroomApi;
